import { IStateService } from 'angular-ui-router';
import { IPublicEsignaturesApi } from '../../services/public-esignatures-api';
import { PreauthTokenErrorEnum } from '../../data/preauth-token-error-codes';

export interface AuthToken {
    token: string,
    fromStorage: boolean
}
export class EsignaturesSignController {
    static $inject: string[] = [
        'authToken',
        'documentUrl',
        '$state',
        'PublicEsignaturesApi'
    ];
    showRequestSignModal = true;
    token: string;
    private metaTagExisted = false;
    private metaTagOriginalContent: string;

    constructor(
        authToken: string,
        public documentUrl: string,
        public $state: IStateService,
        public PublicEsignaturesApi: IPublicEsignaturesApi
    ) {
        this.token = authToken;

        const metaTag = document.querySelector('meta[name="viewport"]');
        this.metaTagExisted = metaTag != null;

        if (this.metaTagExisted) {
            this.metaTagOriginalContent = metaTag.getAttribute('content');
            metaTag.setAttribute('content', 'width=device-width, initial-scale=1');
        } else {
            const newMetaTag = document.createElement('meta');
            newMetaTag.setAttribute('name', 'viewport');
            newMetaTag.setAttribute('content', 'width=device-width, initial-scale=1');
            document.head.appendChild(newMetaTag);
        }
    }

    public $onDestroy(): void {
        const metaTag = document.querySelector('meta[name="viewport"]');
        if (this.metaTagExisted) {
            metaTag.setAttribute('content', this.metaTagOriginalContent);
        } else {
            document.head.removeChild(metaTag);
        }
    }

    getClientConfig = () => {
        return this.PublicEsignaturesApi.getClientConfig({ token: this.token });
    };

    onRequestSigned() {
        this.PublicEsignaturesApi.setIsSigned({ token: this.token })
            .then(() => {
                this.$state.go('authentication.esignatures.signed');
            })
            .catch((response) => {
                switch (response.ErrorCode) {
                    case PreauthTokenErrorEnum.PreAuthTokenAlreadyUsed:
                        return this.$state.go('authentication.esignatures.signed');
                    case PreauthTokenErrorEnum.PreAuthTokenExpired:
                    case PreauthTokenErrorEnum.PreAuthTokenInvalid:
                    default:
                        return this.$state.go('authentication.esignatures.expired');
                }
            });
    }
}
